import { Component, Input, TemplateRef, OnDestroy, ApplicationRef, createComponent, EmbeddedViewRef, Injector } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-magnifier',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './magnifier.component.html',
  styleUrl: './magnifier.component.css'
})
export class MagnifierComponent implements OnDestroy {
  @Input() contentTemplate: TemplateRef<any> | null = null;
  showMagnifier = false;
  private overlayContainer: HTMLDivElement | null = null;
  private hoverRect: DOMRect | null = null;

  constructor(
    private appRef: ApplicationRef,
    private injector: Injector
  ) {}

  private createOverlay() {
    if (!this.overlayContainer) {
      this.overlayContainer = document.createElement('div');
      this.overlayContainer.style.position = 'fixed';
      this.overlayContainer.style.top = '0';
      this.overlayContainer.style.left = '0';
      this.overlayContainer.style.width = '100vw';
      this.overlayContainer.style.height = '100vh';
      this.overlayContainer.style.pointerEvents = 'none';
      this.overlayContainer.style.zIndex = '999999';
      
      const overlayContent = document.createElement('div');
      overlayContent.className = 'magnify-overlay';
      this.overlayContainer.appendChild(overlayContent);
      
      const magnifier = document.createElement('div');
      magnifier.className = 'svg-magnifier';
      
      // Set initial position based on hover location
      if (this.hoverRect) {
        magnifier.style.setProperty('--hover-left', `${this.hoverRect.left + this.hoverRect.width/2}px`);
        magnifier.style.setProperty('--hover-top', `${this.hoverRect.top + this.hoverRect.height/2}px`);
        magnifier.style.setProperty('--hover-width', `${this.hoverRect.width}px`);
        magnifier.style.setProperty('--hover-height', `${this.hoverRect.height}px`);
      }
      
      const content = document.createElement('div');
      content.className = 'magnified-content';

      // Trigger animations after a brief delay
      requestAnimationFrame(() => {
        overlayContent.classList.add('show');
        magnifier.classList.add('show');
      });
      
      if (this.contentTemplate) {
        const viewRef = this.contentTemplate.createEmbeddedView(this.injector);
        this.appRef.attachView(viewRef);
        const contentWrapper = document.createElement('div');
        contentWrapper.style.transformOrigin = 'center';
        contentWrapper.appendChild(viewRef.rootNodes[0]);
        content.appendChild(contentWrapper);
      }
      
      magnifier.appendChild(content);
      this.overlayContainer.appendChild(magnifier);
      document.body.appendChild(this.overlayContainer);
    }
  }

  private removeOverlay() {
    if (this.overlayContainer) {
      document.body.removeChild(this.overlayContainer);
      this.overlayContainer = null;
    }
  }

  onMouseEnter(event: MouseEvent) {
    const target = event.currentTarget as HTMLElement;
    const rect = target.getBoundingClientRect();
    this.hoverRect = rect;
    
    // Create overlay first without show class
    this.createOverlay();
    
    // Force a reflow before adding show class
    setTimeout(() => {
      this.showMagnifier = true;
    }, 50);
  }

  onMouseLeave() {
    this.showMagnifier = false;
    this.removeOverlay();
  }

  ngOnDestroy() {
    this.removeOverlay();
  }

}
